<div class="create-payment-drawer">
  <div class="create-payment-drawer__header">
    <h3 class="create-payment-drawer__title">Create Payment</h3>
    <button
      dataSelector="create-payment-drawer-close-button"
      aria-label="Close drawer"
      type="button"
      class="button button--sm button--text"
      (click)="cancel()"
    >
      <anduin-icon name="x" />
    </button>
  </div>

  <div class="create-payment-drawer__body">
    <app-new-transaction
      [dialogMode]="true"
      [overrideClientId]="clientId()"
      [overrideTransactionType]="CreditArTranType.RECEIPT"
      [prefilledAmount]="outstandingAmount()"
      [preselectedInvoiceNumber]="invoiceNumber()"
      (newTransactionChange)="onTransactionChange($event)"
    />
  </div>

  <div class="create-payment-drawer__footer">
    <button dataSelector="create-payment-drawer-cancel-button" type="button" (click)="cancel()" andButton color="secondary">Cancel</button>
    <button dataSelector="create-payment-drawer-save-button" type="button" (click)="save()" andButton color="primary">Save Payment</button>
  </div>
</div>
